import AppBar from "@material-ui/core/AppBar/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import React from "react";
import {makeStyles} from "@material-ui/core";
import clsx from 'clsx';
import {ToggleSideBarButton} from "./ToggleSideBarButton";
import UserProfileToggle from "./UserProfileToggle";
import {useTranslation} from "react-i18next";
import {useOrganization} from "../../components/organizations/organization-context";
import reactsLogo from './philips-reacts-left.svg';
import {useNavigate} from "react-router-dom";

const useStyles = makeStyles(theme => ({
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        })
    },
    toolbar: {
        justifyContent: 'space-between'
    },
    title: {
        [theme.breakpoints.down('xs')]: {
            display: 'none'
        },
        display: 'flex',
        alignItems: 'center',
        height: '100%',
        minWidth: '0'
    },
    profileItem: {
        textAlign: 'center'
    },
    reactsLogo: {
        height: '80%',
        marginRight: '10px',
        cursor: 'pointer'
    }
}));
export const Header = (props: any) => {
    const classes = useStyles();
    const [currentOrganization] = useOrganization();
    const {drawerIsOpen, toggleDrawerClicked} = props;
    const navigate = useNavigate();
    const {t} = useTranslation();

    return (<AppBar position="absolute"
                    className={clsx(classes.appBar, props.drawerIsOpen && (classes as any).appBarShift)}>
        <Toolbar className={classes.toolbar}>
            <ToggleSideBarButton drawerIsOpen={drawerIsOpen} toggleDrawerClicked={toggleDrawerClicked}/>
            <div className={classes.title}>
                <img src={reactsLogo} className={classes.reactsLogo} onClick={() => navigate(`/organizations`)}/>
                <Typography component="h1" variant="h6" color="inherit" noWrap>
                    {currentOrganization?.name ?? t('_Common.AppTitle')}
                </Typography>
            </div>
            <UserProfileToggle /*className={classes.profileItem}*//>
        </Toolbar>
    </AppBar>);
};
